import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import FormData from 'form-data';
import { createPromise } from 'utils/action';
import { View, Image } from '@zhike/ti-ui';
import { handlePractice } from 'components/listen/utils';
import Header from 'components/listen/header';
import styles from 'components/listen/styles';
import { Error } from '@zhike/ti-component'
import Loading from 'components/loading';
import Content from './content';

// 初始化
export default class Repeat extends Component {
  // 参数
  static propTypes = {
    match: PropTypes.object.isRequired,
    getPractice: PropTypes.func.isRequired,
    getUploadSignature: PropTypes.func.isRequired,
    postCorrectionImage: PropTypes.func.isRequired,
    postCorrection: PropTypes.func.isRequired,
    postRepeat: PropTypes.func.isRequired,
    getRepeatDetail: PropTypes.func.isRequired,
    postRepeatAnswer: PropTypes.func.isRequired,
    postRepeatComplete: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isCompatible: true,
      isLoad: false,
      practice: {
        name: '',
        examId: 1,
      },
      repeatParts: [],
      answersDict: {},
    }
  }

  async componentDidMount() {
    this.checkCompatibal()

    const { match, getPractice, postRepeat, getRepeatDetail } = this.props
    const { practiceId } = match.params
    const search = global.location.search; // eslint-disable-line
    const taskId = decodeURIComponent(search.match(new RegExp('[?#&]task_id=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    try {
      const practiceData = await createPromise(getPractice, { id: practiceId })
      const practice = handlePractice({
        practice: practiceData,
      })

      const { listenParts, exampleParts } = practice
      const repeatParts = listenParts.concat(exampleParts)
      let repeat = {}

      if (repeatParts.length) {
        // 有跟读材料时查询跟读进度并映射到页面中，如果没有就新建一个
        const repeatData = await createPromise(getRepeatDetail, { practiceId, detail: '1' })

        if (!repeatData.data) {
          const initRepat = await createPromise(postRepeat, { practiceId, taskId, source })
          repeat = { id: initRepat.data.id, answers: [] }
        } else {
          repeat = repeatData.data
        }
      }

      const answersDict = this.pushAnswers(repeat)

      this.setState({ isLoad: true, practice, repeatParts, answersDict })

      // console.log(practice, answersDict)
    } catch (e) {
      this.setState({ isLoad: true })
    }
  }

  // 检测兼容性
  checkCompatibal = () => {
    if (
      global.navigator.userAgent.match(/msie/i) ||
      global.ActiveXObject ||
      ('ActiveXObject') in global
    ) {
      this.setState({
        isCompatible: false,
      })
    }
  }

  // 把现有的答案存进字典，传入组件，以保证统一的结构和更快地映射
  pushAnswers = repeat => {
    const answersDict = {
      exerciseId: repeat.id,
      answers: {},
    }

    if (repeat.answers && repeat.answers.length) {
      for (const answer of repeat.answers) {
        answersDict.answers[answer.index] = answer
      }
    }

    return answersDict
  }

  /**
   * 上传用户录音
   * data: 用户的录音数据
   * reTry: 第一次上传失败时自动重试一次，并添加重试标志，第二次依然失败时才放弃
   * signature: 上传阿里云的签名，在第一次上传失败后重试，可以直接传入已经获取的签名，不用重新获取
   * formData: 数据结构，同上，可以在重试时直接传入
   */
  handleRecord = async ({ data, reTry, signature, formData }) => {
    try {
      if (!signature || !formData) {
        const { getUploadSignature } = this.props

        signature = await createPromise(getUploadSignature, {
          business: 'exercise/speaking',
          fileName: `${Date.now()}.webm`,
        });

        formData = new FormData();
        formData.append('key', signature.data.key);
        formData.append('policy', signature.data.policy);
        formData.append('OSSAccessKeyId', signature.data.accessKeyId);
        formData.append('signature', signature.data.signature);
        formData.append('callback', signature.data.callback);
        formData.append('file', data.blob);
      }

      const audioData = await axios({
        url: signature.data.uploadAddress,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
        timeout: 20000,
      });

      return Promise.resolve(audioData.data.data.transcodeUrl)
    } catch (e) {
      console.error(e)

      return reTry
        ? Promise.reject()
        : this.handleRecord({ data, signature, formData, reTry: true })
    }
  }

  // 用户录音提交批改，在上传成功后调用
  handlePigai = async ({ url, index, transcript, reTry }) => {
    try {
      const { postRepeatAnswer } = this.props
      const { exerciseId } = this.state.answersDict

      const pigaiData = await createPromise(postRepeatAnswer, {
        audioUrl: url,
        transcript,
        exerciseId,
        index,
      })

      await this.updateAnswersDict({
        exerciseId,
        index,
        answer: {
          audioUrl: url,
          transcript,
        },
        machinePigaiResult: pigaiData.data.machinePigaiResult,
      })

      return Promise.resolve()
    } catch (e) {
      console.error(e)

      return reTry
        ? Promise.reject()
        : this.handlePigai({ url, index, transcript, reTry: true })
    }
  }

  // 上传用户录音并获取打分结果后，更新answers字典
  updateAnswersDict = async res => {
    const { repeatParts, answersDict } = this.state
    const sentenceSum = repeatParts.reduce((sum, item) => (
      sum + item.translation.length
    ), 0)

    answersDict.answers[res.index] = res

    await this.setState({ answersDict })

    if (Object.keys(answersDict.answers).length >= sentenceSum) { // 所有句子跟读完
      const search = global.location.search; // eslint-disable-line
      const taskId = decodeURIComponent(search.match(new RegExp('[?#&]task_id=([^?#&]+)', 'i')) ? RegExp.$1 : '');
      const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
      try {
        await createPromise(this.props.postRepeatComplete, { id: res.exerciseId, taskId, source })
      } catch (e) {
        console.error(e)
      }
    }

    console.log(res)
  }

  // 获取当前句子在所有材料里面的索引序号
  getSentenceIndex = active => {
    const partId = +this.props.match.params.partId || 1
    const { repeatParts } = this.state
    let sentenceIndex = active

    for (let i = 0; i < repeatParts.length; i += 1) {
      if (i < partId - 1) {
        sentenceIndex += repeatParts[i].translation.length
      } else {
        break
      }
    }

    return sentenceIndex
  }

  // 我要纠错
  handleFeedback = () => {
    if (this.header) {
      this.header.handleCorrect();
    }
  }

  // 渲染
  render() {
    const { match, getUploadSignature, postCorrection, postCorrectionImage } = this.props
    const { isCompatible, isLoad, practice, repeatParts, answersDict } = this.state
    const partId = +match.params.partId || 1
    const repeatPart = repeatParts[partId - 1]

    const renderPropsForHeader = {
      match,
      getUploadSignature,
      postCorrectionImage,
      postCorrection,
      ...practice,
      type: 'repeat',
    }
    const renderPropsForContent = {
      repeatPart,
      answersDict,
      handleRecord: this.handleRecord,
      handlePigai: this.handlePigai,
      handleFeedback: this.handleFeedback,
      getSentenceIndex: this.getSentenceIndex,
    }

    return (
      <View className={styles.container}>
        {
          !isCompatible &&
          <Error match={{ params: { type: 'compatible' } }} />
        }
        {
          !isLoad && isCompatible &&
          <Loading text="正在加载数据，请稍候..." />
        }
        {
          isLoad && isCompatible &&
          <Header ref={ref => { this.header = ref }} {...renderPropsForHeader} />
        }
        {
          isLoad && isCompatible && !repeatPart &&
          <View className={[styles.loadingBox, styles.errorContainer]}>
            <Image
              className={styles.loading}
              src={require('components/assets/fail.png')}
            />
            <View className={[styles.text, styles.errorText]}>
              跟读资源格式错误，请将问题 <View className={styles.feedback} onClick={this.handleFeedback}>反馈</View> 给我们
            </View>
          </View>
        }
        {
          isLoad && isCompatible && repeatPart &&
          <Content {...renderPropsForContent} />
        }
      </View>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/repeat/index.js